import React from "react";
import { useParams, Link } from "react-router-dom";
import data from "../../data/projects.json";
import "./Project.css";

function Project() {
  const { slug } = useParams();
  const project = data.find((p) => p.slug === slug);

  if (!project) {
    return (
      <section className="Project">
        <h1 className="Project__title">Not found</h1>
        <p className="Project__desc">We couldn’t find that project.</p>
        <p className="Project__back">
          <Link to="/">← Back to Home</Link>
        </p>
      </section>
    );
  }

  const {
    title,
    year,
    role,
    synopsis,
    runtime,
    logline,
    videoUrl,
    stills = [],
  } = project;

  return (
    <section className="Project">
      <header className="Project__header">
        <h1 className="Project__title">{title}</h1>
        <div className="Project__meta">
          {year && <span>{year}</span>}
          {role && <span>• {role}</span>}

          {runtime && <span>• {runtime}</span>}
        </div>
        {logline && <p className="Project__logline">{logline}</p>}
      </header>

      {videoUrl && (
        <div className="Project__videoWrap">
          <iframe
            className="Project__video"
            src={videoUrl}
            allow="autoplay; fullscreen"
            loading="lazy"
            title={title}
          ></iframe>
        </div>
      )}

      {/* NEW: Under-video synopsis/credits block */}
      {/* Under-video synopsis */}
      <section className="Project__synopsis">
        <h2 className="Project__synopsisTitle">Synopsis</h2>

        <div className="Project__synopsisCard">
          <p className="Project__synopsisLead">{title}</p>
          {synopsis && <p className="Project__synopsisText">{synopsis}</p>}
        </div>
      </section>

      {!!stills.length && (
        <div className="Project__stills">
          {stills.map((src, i) => (
            <img
              key={i}
              className="Project__still"
              src={src}
              alt={`${title} still ${i + 1}`}
              loading="lazy"
            />
          ))}
        </div>
      )}

      <p className="Project__back">
        <Link to="/">← Back to Home</Link>
      </p>
    </section>
  );
}

export default Project;
